import React from "react";
import logo from "./logo.svg";
import "./Preloader.scss";

function Preloader() {
  return (
    <>
      {/* Preloader Start !*/}
      <div id="preloader">
        <div id="preloader-status">
          <div className="loading-container">
            <div className="ball1" />
            <div className="ball2" />
            <div className="ball3" />
            <div className="ball4" />
          </div>
        </div>
      </div>
      {/* Preloader End !*/}
    </>
  );
}

export default Preloader;
